'use client';

import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';
import { LayoutHeaderButton } from '#/layouts/Layout/Header/Button/LayoutHeaderButton';
import { useSearchContextHeaderInput } from '#/modules/search/containers/SearchContextHeader/useSearchContextHeaderInput';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

import { LayoutHeaderBackToResultsArrowHolder } from './LayoutHeaderBackToResultsArrow.styled';

type Props = {
  objectId: string;
};

export function LayoutHeaderBackToResultsArrow({ objectId }: Props) {
  const { i18n } = useI18n();

  // NOTE: input hook only, the full one also fetches pages on mount
  const { searchContextInput } = useSearchContextHeaderInput({
    currentObjectId: objectId,
  });

  if (!searchContextInput) return null;

  return (
    <LayoutHeaderBackToResultsArrowHolder>
      <LayoutHeaderButton
        variant="grey"
        smallHorizontalPaddingOnMobile
        ariaLabel={i18n('Back to results')}
        qaId="back-to-results-arrow"
        data={{
          type: 'link-with-state',
          to: searchContextInput.searchResultsUrl,
          state: searchContextInput.searchResultsState,
          onClick: () =>
            trackClicked('Back To Results', { header_position: 'top' }),
        }}
      >
        <Icon name="chevron-left" size={24} />
      </LayoutHeaderButton>
    </LayoutHeaderBackToResultsArrowHolder>
  );
}
